import Cookies from "js-cookie";

class Cookiebar {
  constructor() {
    const cookieTitle = "2bsec";
    const cookiebar = document.getElementById("cookiebar");
    const cookieAcceptButton = cookiebar.querySelector(
      "button.cookie-accept-button",
    );
    this.cookieName = encodeURIComponent("user_aggrement_cookiebar"); // where  is constant of current blog id added in head
    this.cookieValue = cookieTitle ? encodeURIComponent(cookieTitle) : 1; // where  is constant of current blog id added in head
    this.cookiebar = cookiebar;
    this.cookieAcceptButton = cookieAcceptButton;

    if (cookiebar && cookieAcceptButton && cookieTitle) {
      this.cookieCheckups();
    }
  }

  cookieCheckups() {
    let that = this;

    if (Cookies.get(that.cookieName)) {
    } else {
      that.cookieAcceptButton.onclick = () => {
        Cookies.set(that.cookieName, that.cookieValue, {
          expires: 365,
          path: "/",
        });

        if (Cookies.get(that.cookieName)) {
          that.cookiebar.classList.remove("is-visible");
        }
      };
      that.cookiebar.classList.add("is-visible");
    }
  }
}

new Cookiebar();
